import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Dialog, withStyles } from "@material-ui/core";
import Clear from "@material-ui/icons/Clear";
import styles from "./HandOver.module.scss";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CustomerReservationsClient from "../../../../shared/clients/CustomerReservationsClient";
import { HANDOVER_DIALOGUES } from "./Constants";

const StyledClear = withStyles({
  root: {
    width: 27,
    height: 27,
    fill: "#102b4e",
    align: "right",
  },
})(Clear);

const StyledDialog = withStyles({
  paper: {
    maxWidth: 607,
    height: 306,
  },
})(Dialog);

class HandOverCancelAppointmentDialog extends Component {
  handleClose = () => {
    this.props.handleDialogChange(null, HANDOVER_DIALOGUES.CANCEL_APPOINTMENT);
  };

  handleConfirm = () => {
    this.props.handleDialogChange(null, HANDOVER_DIALOGUES.CANCEL_APPOINTMENT);
    const dealerAction = this.getDealerAction();

    this.props.hideOrShow(true);
    CustomerReservationsClient.updateOrder(
      this.props.token,
      this.props.commonId,
      dealerAction,
      this.props.user.userId
    )
      .then(() => {
        this.props.refreshOrderDetails();
      })
      .catch(() => {
        this.props.showErrorPopup(
          this.props.t("Error.processingErrorTitle"),
          this.props.t("Error.processingErrorMessage")
        );
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  getDealerAction() {
    return {
      reservationId: this.props.customerReservation.id,
      dealerAction: "cancelAppointment",
    };
  }

  render() {
    return this.props.open ? (
      <StyledDialog open={this.props.open} onClose={this.handleClose}>
        <div className={styles.dialog}>
          <Grid
            container
            data-testid="handOverCancelAppointmentDialog"
            className={styles.dialogContainer}
            justify="center"
          >
            <Grid item md={12} className={styles.cancel}>
              <div>
                <button
                  data-testid="handOverCancelAppointmentCloseDialog"
                  onClick={this.handleClose}
                >
                  <StyledClear />
                </button>
              </div>
            </Grid>

            <Grid item md={9}>
              <div className={styles.brightRedTitle}>
                <div className={styles.warning} />
                {this.props.t("HandOverCancelAppointmentDialog.title")}
              </div>
            </Grid>

            <Grid item md={9}>
              <div className={styles.body}>
                <div className={styles.text}>
                  {this.props.t("HandOverCancelAppointmentDialog.bodyText")}
                </div>
              </div>
            </Grid>

            <Grid item md={9}>
              <div className={styles.dialogActions}>
                <Button
                  className={styles.cancel}
                  name="handOverCancelAppointmentCancel"
                  data-testid="handOverCancelAppointmentCancel"
                  onClick={this.handleClose}
                >
                  {this.props.t("HandOverCancelAppointmentDialog.cancel")}
                </Button>
                <Button
                  className={styles.next}
                  name="handOverCancelAppointmentConfirm"
                  data-testid="handOverCancelAppointmentConfirm"
                  onClick={this.handleConfirm}
                >
                  {this.props.t("HandOverCancelAppointmentDialog.confirm")}
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </StyledDialog>
    ) : (
      ""
    );
  }
}

export default withTranslation("emp")(HandOverCancelAppointmentDialog);
